// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"c6ae38ee","83":"10586ac9","94":"03d2a415","279":"cc844bef","377":"b12664f3","453":"f88af107","459":"d4e99eb5","855":"fa89402f","920":"eb7382c4","999":"0dd3867d"}[chunkId] + ".chunk.js";
};